// .....................status
export enum DiscountStatus {
    ACTIVE = 1,
    INACTIVE = 2,
}
// .....................status
export enum OrderLimitType {
    MAX = 'max',
    MIN = 'min',
    RANGE = 'range',
    EXACT = 'exact', 
}

export const getDiscountStatusColor = (status: DiscountStatus) => {
    switch (status) {
        case DiscountStatus.ACTIVE:
            return "green";
        case DiscountStatus.INACTIVE:
            return "red";
        default:
            return "red";
    }
};

// Status Boolean stuts
export const getDiscountStatus = (status: DiscountStatus) => {
    switch (status) {
        case DiscountStatus.ACTIVE:
            return "active";
        case DiscountStatus.INACTIVE:
            return "inactive";
        default:
            return "active";
    }
};
export const getOrderLimitType = (orderLimitType: OrderLimitType) => {
    switch (orderLimitType) {
        case OrderLimitType.MIN:
            return "set_min_orders";
        case OrderLimitType.MAX:
            return "set_max_orders";
        case OrderLimitType.RANGE:
            return "set_range_orders";
        case OrderLimitType.EXACT:
            return "set_exact_orders";
        default:
            return "set_range_orders";
    }
};

// ....................type
export enum DiscountType {
    FIXED = 1,
    REPLACEABLE = 2,
}

export const getDiscounteTypeColor = (Type: DiscountType) => {
    switch (Type) {
        case DiscountType.FIXED:
            return "blue";
        case DiscountType.REPLACEABLE:
            return "orange";
        default:
            return "green";
    }
};

// Type Boolean stuts
export const getDiscountType = (Type: DiscountType) => {
    switch (Type) {
        case DiscountType.FIXED:
            return "fixed";
        case DiscountType.REPLACEABLE:
            return "replaceable";
        default:
            return "fixed";
    }
};

// .....................type vlaue

export enum DiscountTypeValue {
    FIXED_AMOUNT = 1,
    PERCENT = 2,
}

export const getDiscounteTypeValueColor = (Type: DiscountTypeValue) => {
    switch (Type) {
        case DiscountTypeValue.FIXED_AMOUNT:
            return "blue";
        case DiscountTypeValue.PERCENT:
            return "orange";
        default:
            return "green";
    }
};

// Type Boolean stuts
export const getDiscountTypeValue = (Type: DiscountTypeValue) => {
    switch (Type) {
        case DiscountTypeValue.FIXED_AMOUNT:
            return "fixed_amount";
        case DiscountTypeValue.PERCENT:
            return "percent";
        default:
            return "percent";
    }
};

// .....................type vlaue

export enum DiscountTypeApp {
    DRIVE = 1,
    PRODUCT = 2,
    PRODUCT_DRIVE = 3,
};
export enum TypeInvitationDiscountCode {
    sending = 1,
    receiving = 2,
};

export enum sponsorType {
    SYSTEM = 1,
    COMPANY = 2,
    SPECIAL_STORE = 3,
};
export const getDiscounteTypeAppColor = (Type: DiscountTypeApp) => {
    switch (Type) {
        case DiscountTypeApp.DRIVE:
            return "blue";
        case DiscountTypeApp.PRODUCT:
            return "orange";
        case DiscountTypeApp.PRODUCT_DRIVE:
            return "orange";
        default:
            return "green";
    }
};

// Type Boolean stuts
export const getDiscountTypeApp = (Type: DiscountTypeApp) => {
    switch (Type) {
        case DiscountTypeApp.DRIVE:
            return "drive";
        case DiscountTypeApp.PRODUCT:
            return "product";
        case DiscountTypeApp.PRODUCT_DRIVE:
            return "all";
        default:
            return "drive";
    }
};

export const getTypeInvitationDiscountCode = (Type: TypeInvitationDiscountCode) => {
    switch (Type) {
        case TypeInvitationDiscountCode.sending:
            return "sending";
        case TypeInvitationDiscountCode.receiving:
            return "receiving";
        default:
            return ;
    }
};

// Type Code giver
export const getsponsorType = (Type: sponsorType) => {
    switch (Type) {
        case sponsorType.SYSTEM:
            return "system";
        case sponsorType.COMPANY:
            return "trademark";
        case sponsorType.SPECIAL_STORE:
            return "special_store";
        default:
            return null;
    }
};

// .....................type user

export enum TypeUserDiscountCode {
    All = 1,
    New = 2,
    Specific = 3,
    guests = 4,
}

export const getTypeUserDiscountCode = (Type: TypeUserDiscountCode) => {
    switch (Type) {
        case TypeUserDiscountCode.All:
            return "all";
        case TypeUserDiscountCode.New:
            return "is_new";
        case TypeUserDiscountCode.Specific:
            return "specific";
        case TypeUserDiscountCode.guests:
            return "guests";
    }
};